module.exports = __webpack_public_path__ + "img/img21.8177b36b.png";